import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import Axios from 'axios';
import EndUser from '../../../utils/eusign';
import { connect } from 'react-redux';
import * as api from '../../../api/api';
import { Grid, Typography } from '@material-ui/core';
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";
import { history } from "../../../utils/hist";
import { CompletedContext } from './StepperComponent';
import {apllicantData} from '../../../redux/actions/applicantAction';
import {getApplicationList, applicationIDAction} from '../../../redux/actions/applicationAction';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { green } from '@material-ui/core/colors';
import PDFViewer from './PDFViewer';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
const MySwal = withReactContent(Swal);
const swalWithBootstrapButtons = MySwal.mixin({
  confirmButtonColor: "#2D5CA6",
  cancelButtonColor: "#FF0000",
  customClass: {
    confirmButton: "br0 ",
    cancelButton: "br0 mr-3"
  },
  buttonsStyling: true
});
function convertDataURIToBinary(dataURI) {
  // const BASE64_MARKER = ';base64,';
  // var base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  // var base64 = dataURI.substring(base64Index);
  var raw = window.atob(dataURI);
  var rawLength = raw.length;
  var array = new Uint8Array(new ArrayBuffer(rawLength));

  for (let i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array;
}

const mapStateToProps = state => {
  return {
    id: state.application.id,
    rnokpp: state.auth.user.rnokpp,
    // euSign: state.eusign.eusign
  };
};

const useCompleted = () => {
  const contextValue = React.useContext(CompletedContext);
  return contextValue;
};

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  wrapper: {
    margin: theme.spacing(1),
    position: 'relative',
  },
  buttonSuccess: {
    backgroundColor: green[500],
    '&:hover': {
      backgroundColor: green[700],
    },
  },
  fabProgress: {
    color: green[500],
    position: 'absolute',
    top: -6,
    left: -6,
    zIndex: 1,
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
}));

export default connect(mapStateToProps, {apllicantData, getApplicationList, applicationIDAction})(function PreviewDeclaration(props) {
  const [completed, dispatch] = useCompleted();
  const [numPages, setPageNumber] = React.useState();
  // const euSignedRef = React.useRef( null );
  const [euSign, setEuSign] = React.useState('');
  const [dataSign, setDataSign] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);
  const classes = useStyles();
  const pageNumber = 1;
  

  function onDocumentLoadSuccess({ numPages }) {
    setPageNumber(numPages);
  }

  async function signSend(uriBinary) {
    var previousSign = null;
    var external = true;
    var asBase64String = true;
    var signAlgo = EndUser.SignAlgo.DSTU4145WithGOST34311;
    var signType = 16;

    const URI_BINARY = convertDataURIToBinary(uriBinary);
    // console.log(props.euSign.SignData);
    const newCompleted = completed;
    if (!loading) {
      setSuccess(false);
      setLoading(true);

    
    euSign
      .SignData(URI_BINARY, external, asBase64String, signAlgo, null, signType)
      .then(async sign => {
        // console.log(sign);
        
        try {
          const data = {
            id: props.id,
            sign,
            fileName: props.fileDeclaration
          };
           const response =  await api.aproveApp(data);
           setSuccess(true);
           setLoading(false);
          swalWithBootstrapButtons.fire({
            title: response.data,
            type: 'success'
          })
          .then(result => {
            if (result.value) {
              props.apllicantData(props.id)
              newCompleted[props.activeStep] = true;
              dispatch({ type: 'COMPLETED', payload: newCompleted });

              props.getApplicationList(props.rnokpp);
              props.applicationIDAction(0);
              history.push('/profile-page');
            }
          })
          
         
        } catch (error) {
          setSuccess(false);
           setLoading(false);
          newCompleted[props.activeStep] = true;
          dispatch({ type: 'COMPLETED', payload: newCompleted });
        }
      })
      .catch(err => {
        setSuccess(false);
           setLoading(false);
           swalWithBootstrapButtons.fire({
            title: err.message,
            type: 'error'
          });
      });
    }
  }

  async function handleSign() {
    const obj ={
      fileName: props.fileDeclaration
    }
    try {
      const { data } = await api.getFile(obj);
      signSend(data);
    } catch (error) {}
  }

  async function readKey(euSign) {
   
    try {
      const data = await euSign.ReadPrivateKey();
      // console.log(data);
      setDataSign(data);
      return data;
    } catch (error) {
      // console.log(error);
    }
  }

  

  function initWidget() {
    /*
  Ідентифікатор батківського елементу для відображення iframe, 
  який завантажує сторінку SignWidget
  */
    const SIGN_WIDGET_PARENT_ID = 'sign-widget-parent';
    /*
 Ідентифікатор iframe, який завантажує сторінку SignWidget
 */
    const SIGN_WIDGET_ID = 'sign-widget';
    /*
 URI з адресою за якою розташована сторінка SignWidget
 */
    // const SIGN_WIDGET_URI = 'https://eu.iit.com.ua/sign-widget/v20200311';
    const SIGN_WIDGET_URI =
      'https://id.gov.ua/sign-widget/v20200311/?address=https://dopomoga2fop.ioc.gov.ua&formType=1&debug=false';

    //=============================================================================

    /*
 Створення об'єкту типу EndUser для взаємодії з iframe, 
 який завантажує сторінку SignWidget
 */
    var euSign = new EndUser(
      SIGN_WIDGET_PARENT_ID,
      SIGN_WIDGET_ID,
      SIGN_WIDGET_URI,
      EndUser.FormType.ReadPKey
    );

    setEuSign(euSign);

    return euSign;
  }

  React.useEffect(() => {
    // let timer = setTimeout(() => euSignedRef.current = initWidget(), 1000);
    let timer = setTimeout(() => initWidget(), 1000);
    // readKey(props.euSign)
    return () => {
      clearTimeout(timer);
    };
  }, []);

  React.useEffect(() => {
    
readKey(euSign)

     
  }, [euSign]);

  React.useEffect(() => {
    setDataSign(dataSign);
  }, [dataSign]);

  // console.log(euSignedRef);

  const onClose = () => {
    setSuccess(false);
    setLoading(false);
    props.handleClose()
  }

  return (
    <div>
      <Dialog
        maxWidth="lg"
        open={props.open}
        onClose={onClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Заява</DialogTitle>
        <DialogContent>
          <Grid
            container
            justify="flex-start"
            alignItems="flex-start"
            direction="row"
            spacing={2}
          >
            <Grid item xs={12} sm={12} md={6}>
              {/* <Document
                // file={`/fop/file/${props.fileDeclaration}`}
                file={{
                  url: `/fop/file/${props.fileDeclaration}`,
                  httpHeaders: {
                    'Authorization': `Bearer ${localStorage.jwtToken}`,
                  },
                  withCredentials: true,
                }}
                onLoadSuccess={onDocumentLoadSuccess}
              >
                <Page pageNumber={pageNumber} />
              </Document> */}
              <PDFViewer filePreview={props.fileDeclaration}/>
              {/* <p>
            Page {pageNumber} of {numPages}
          </p> */}
            </Grid>
            <Grid item xs={12} sm={12} md={6}>
              {/* {!(dataSign.length > 0) && <div
                id="sign-widget-parent"
                style={{ width: '550px', height: '500px' }}
              />} */}
              <Typography component="h4" color="error" className="text-center">
              "УВАГА! 
              </Typography>
              <Typography component="p" color="error" className="text-center">
              Оскільки допомога призначається фізичній особі - людині, для підпису заяви використовувати виключно КЕП, що виданий на фізичну особу, а не КЕП для ФОП як суб'єкт господарчих відносин"
              </Typography>
              <div
                id="sign-widget-parent"
                style={{ width: '550px', height: '500px' }}
              />
            </Grid>
            {/* <button onClick={() => readKey(euSign)}>test</button> */}
          </Grid>
  
        </DialogContent>
        <DialogActions>
          <Button
            onClick={onClose}
            cvariant="contained"
            color="default"
          >
            Відміна
          </Button>
          <div className={classes.wrapper}>

          
          {dataSign.length > 0 && (
            <Button onClick={handleSign} color="primary" variant="contained" disabled={loading || success}>
              Підписати/Відправити
            </Button>
          )}
          {loading && <CircularProgress size={24} className={classes.buttonProgress} disabled={loading} />}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
});
